/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by build/build.js.
// Do not modify manually, please do: bun run build:minimap.
//

import { DefaultMinimap as M } from "./DefaultMinimap"

export const InvokeMap: Record<string, string> = {
  [M.invoke_ii]: M.dynCall_ii,
  [M.invoke_iii]: M.dynCall_iii,
  [M.invoke_iiii]: M.dynCall_iiii,
  [M.invoke_iiiii]: M.dynCall_iiiii,
  [M.invoke_iiiiii]: M.dynCall_iiiiii,
  [M.invoke_iiiiiii]: M.dynCall_iiiiiii,
  [M.invoke_iiiiiiii]: M.dynCall_iiiiiiii,
  [M.invoke_iiiiiiiii]: M.dynCall_iiiiiiiii,
  [M.invoke_iiiiiiiiii]: M.dynCall_iiiiiiiiii,
  [M.invoke_iiiiiiiiiiii]: M.dynCall_iiiiiiiiiiii,
  [M.invoke_v]: M.dynCall_v,
  [M.invoke_vi]: M.dynCall_vi,
  [M.invoke_vii]: M.dynCall_vii,
  [M.invoke_viii]: M.dynCall_viii,
  [M.invoke_viiii]: M.dynCall_viiii,
  [M.invoke_viiiii]: M.dynCall_viiiii,
  [M.invoke_viiiiii]: M.dynCall_viiiiii,
  [M.invoke_viiiiiii]: M.dynCall_viiiiiii,
  [M.invoke_viiiiiiii]: M.dynCall_viiiiiiii,
  [M.invoke_viiiiiiiii]: M.dynCall_viiiiiiiii,
  [M.invoke_iiji]: M.dynCall_iiji,
  [M.invoke_iji]: M.dynCall_iji,
  [M.invoke_jji]: M.dynCall_jji,
  [M.invoke_jiji]: M.dynCall_jiji,
  [M.invoke_iij]: M.dynCall_iij,
  [M.invoke_jii]: M.dynCall_jii,
  [M.invoke_ji]: M.dynCall_ji,
  [M.invoke_diiid]: M.dynCall_diiid,
  [M.invoke_iidi]: M.dynCall_iidi,
  [M.invoke_iddii]: M.dynCall_iddii,
  [M.invoke_iiiiiij]: M.dynCall_iiiiiij,
  [M.invoke_iiiiiiiiiijj]: M.dynCall_iiiiiiiiiijj,
  [M.invoke_iiiiiiiiiiji]: M.dynCall_iiiiiiiiiiji,
  [M.invoke_iiiiiiijjii]: M.dynCall_iiiiiiijjii,
  [M.invoke_iijiii]: M.dynCall_iijiii,
  [M.invoke_iiijiii]: M.dynCall_iiijiii,
  [M.invoke_iiiijj]: M.dynCall_iiiijj,
  [M.invoke_iidiii]: M.dynCall_iidiii,
  [M.invoke_fdi]: M.dynCall_fdi,
  [M.invoke_idii]: M.dynCall_idii,
  [M.invoke_iiiiiiiifi]: M.dynCall_iiiiiiiifi,
  [M.invoke_vijii]: M.dynCall_vijii,
  [M.invoke_iiiijii]: M.dynCall_iiiijii,
  [M.invoke_iiiiijiiiii]: M.dynCall_iiiiijiiiii,
  [M.invoke_fdii]: M.dynCall_fdii,
  [M.invoke_viiiiiiiiijiiii]: M.dynCall_viiiiiiiiijiiii,
  [M.invoke_id]: M.dynCall_id,
  [M.invoke_dd]: M.dynCall_dd,
  [M.invoke_viij]: M.dynCall_viij,
  [M.invoke_fdd]: M.dynCall_fdd,
  [M.invoke_iiiij]: M.dynCall_iiiij,
  [M.invoke_iiiiijiiii]: M.dynCall_iiiiijiiii,
  [M.invoke_iiijii]: M.dynCall_iiijii,
  [M.invoke_iiiijiiii]: M.dynCall_iiiijiiii,
  [M.invoke_iiiji]: M.dynCall_iiiji,
  [M.invoke_iidiiii]: M.dynCall_iidiiii,
  [M.invoke_iijii]: M.dynCall_iijii,
  [M.invoke_iijj]: M.dynCall_iijj,
  [M.invoke_iijjjjjj]: M.dynCall_iijjjjjj,
  [M.invoke_viiiiiiiiiiiiiijiiiii]: M.dynCall_viiiiiiiiiiiiiijiiiii,
  [M.invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii]: M.dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii,
  [M.invoke_iiiiiiiiiiiiiiiii]: M.dynCall_iiiiiiiiiiiiiiiii,
  [M.invoke_iiiiiiiiiiiiii]: M.dynCall_iiiiiiiiiiiiii,
  [M.invoke_iiiiiiiiiiiii]: M.dynCall_iiiiiiiiiiiii,
  [M.invoke_iiiiiiiiiiiiiiii]: M.dynCall_iiiiiiiiiiiiiiii,
  [M.invoke_iiiiiiiiiii]: M.dynCall_iiiiiiiiiii,
  [M.invoke_iiiiiiiiiiiiiii]: M.dynCall_iiiiiiiiiiiiiii,
  [M.invoke_djijd]: M.dynCall_djijd,
  [M.invoke_fdj]: M.dynCall_fdj,
  [M.invoke_fdjj]: M.dynCall_fdjj,
  [M.invoke_iddjj]: M.dynCall_iddjj,
  [M.invoke_idjj]: M.dynCall_idjj,
  [M.invoke_iidjjj]: M.dynCall_iidjjj,
  [M.invoke_iijjj]: M.dynCall_iijjj,
  [M.invoke_ij]: M.dynCall_ij,
  [M.invoke_ijdj]: M.dynCall_ijdj,
  [M.invoke_ijii]: M.dynCall_ijii,
  [M.invoke_ijiii]: M.dynCall_ijiii,
  [M.invoke_ijiiii]: M.dynCall_ijiiii,
  [M.invoke_ijiiiiiii]: M.dynCall_ijiiiiiii,
  [M.invoke_ijiiiiiiji]: M.dynCall_ijiiiiiiji,
  [M.invoke_ijiiiij]: M.dynCall_ijiiiij,
  [M.invoke_ijiiiijiii]: M.dynCall_ijiiiijiii,
  [M.invoke_ijiiiijij]: M.dynCall_ijiiiijij,
  [M.invoke_ijiiij]: M.dynCall_ijiiij,
  [M.invoke_ijiiijjiiiiii]: M.dynCall_ijiiijjiiiiii,
  [M.invoke_ijiij]: M.dynCall_ijiij,
  [M.invoke_ijiiji]: M.dynCall_ijiiji,
  [M.invoke_ijiijj]: M.dynCall_ijiijj,
  [M.invoke_ijij]: M.dynCall_ijij,
  [M.invoke_ijiji]: M.dynCall_ijiji,
  [M.invoke_ijijijj]: M.dynCall_ijijijj,
  [M.invoke_ijijj]: M.dynCall_ijijj,
  [M.invoke_ijijjj]: M.dynCall_ijijjj,
  [M.invoke_ijijjjj]: M.dynCall_ijijjjj,
  [M.invoke_ijj]: M.dynCall_ijj,
  [M.invoke_ijji]: M.dynCall_ijji,
  [M.invoke_ijjii]: M.dynCall_ijjii,
  [M.invoke_ijjiiiij]: M.dynCall_ijjiiiij,
  [M.invoke_ijjiiiijjii]: M.dynCall_ijjiiiijjii,
  [M.invoke_ijjiiij]: M.dynCall_ijjiiij,
  [M.invoke_ijjiiijjji]: M.dynCall_ijjiiijjji,
  [M.invoke_ijjiij]: M.dynCall_ijjiij,
  [M.invoke_ijjiijiiii]: M.dynCall_ijjiijiiii,
  [M.invoke_ijjiijiiiii]: M.dynCall_ijjiijiiiii,
  [M.invoke_ijjiijiiiiji]: M.dynCall_ijjiijiiiiji,
  [M.invoke_ijjiijiiiijii]: M.dynCall_ijjiijiiiijii,
  [M.invoke_ijjiijiiiijiij]: M.dynCall_ijjiijiiiijiij,
  [M.invoke_ijjiijiiiijj]: M.dynCall_ijjiijiiiijj,
  [M.invoke_ijjiijjjjiiiiiiii]: M.dynCall_ijjiijjjjiiiiiiii,
  [M.invoke_ijjiijjjjjjjiiii]: M.dynCall_ijjiijjjjjjjiiii,
  [M.invoke_ijjij]: M.dynCall_ijjij,
  [M.invoke_ijjiji]: M.dynCall_ijjiji,
  [M.invoke_ijjijiii]: M.dynCall_ijjijiii,
  [M.invoke_ijjijj]: M.dynCall_ijjijj,
  [M.invoke_ijjijjj]: M.dynCall_ijjijjj,
  [M.invoke_ijjj]: M.dynCall_ijjj,
  [M.invoke_ijjji]: M.dynCall_ijjji,
  [M.invoke_ijjjii]: M.dynCall_ijjjii,
  [M.invoke_ijjjiiiiiiii]: M.dynCall_ijjjiiiiiiii,
  [M.invoke_ijjjiiiji]: M.dynCall_ijjjiiiji,
  [M.invoke_ijjjiiijj]: M.dynCall_ijjjiiijj,
  [M.invoke_ijjjij]: M.dynCall_ijjjij,
  [M.invoke_ijjjijj]: M.dynCall_ijjjijj,
  [M.invoke_ijjjijji]: M.dynCall_ijjjijji,
  [M.invoke_ijjjj]: M.dynCall_ijjjj,
  [M.invoke_ijjjji]: M.dynCall_ijjjji,
  [M.invoke_ijjjjii]: M.dynCall_ijjjjii,
  [M.invoke_ijjjjj]: M.dynCall_ijjjjj,
  [M.invoke_ijjjjji]: M.dynCall_ijjjjji,
  [M.invoke_ijjjjjij]: M.dynCall_ijjjjjij,
  [M.invoke_ijjjjjj]: M.dynCall_ijjjjjj,
  [M.invoke_ijjjjjji]: M.dynCall_ijjjjjji,
  [M.invoke_ijjjjjjiij]: M.dynCall_ijjjjjjiij,
  [M.invoke_ijjjjjjijii]: M.dynCall_ijjjjjjijii,
  [M.invoke_ijjjjjjj]: M.dynCall_ijjjjjjj,
  [M.invoke_ijjjjjjjfj]: M.dynCall_ijjjjjjjfj,
  [M.invoke_ijjjjjjjj]: M.dynCall_ijjjjjjjj,
  [M.invoke_ijjjjjjjji]: M.dynCall_ijjjjjjjji,
  [M.invoke_ijjjjjjjjj]: M.dynCall_ijjjjjjjjj,
  [M.invoke_ijjjjjjjjjj]: M.dynCall_ijjjjjjjjjj,
  [M.invoke_ijjjjjjjjjjj]: M.dynCall_ijjjjjjjjjjj,
  [M.invoke_ijjjjjjjjjjjjj]: M.dynCall_ijjjjjjjjjjjjj,
  [M.invoke_ijjjjjjjjjjjjjj]: M.dynCall_ijjjjjjjjjjjjjj,
  [M.invoke_jj]: M.dynCall_jj,
  [M.invoke_jjii]: M.dynCall_jjii,
  [M.invoke_jjiii]: M.dynCall_jjiii,
  [M.invoke_jjiiiii]: M.dynCall_jjiiiii,
  [M.invoke_jjiijj]: M.dynCall_jjiijj,
  [M.invoke_jjij]: M.dynCall_jjij,
  [M.invoke_jjijjjji]: M.dynCall_jjijjjji,
  [M.invoke_jjj]: M.dynCall_jjj,
  [M.invoke_jjji]: M.dynCall_jjji,
  [M.invoke_jjjiii]: M.dynCall_jjjiii,
  [M.invoke_jjjiijjj]: M.dynCall_jjjiijjj,
  [M.invoke_jjjj]: M.dynCall_jjjj,
  [M.invoke_jjjji]: M.dynCall_jjjji,
  [M.invoke_jjjjiijii]: M.dynCall_jjjjiijii,
  [M.invoke_jjjjj]: M.dynCall_jjjjj,
  [M.invoke_jjjjji]: M.dynCall_jjjjji,
  [M.invoke_jjjjjj]: M.dynCall_jjjjjj,
  [M.invoke_viiiiiijji]: M.dynCall_viiiiiijji,
  [M.invoke_viiiijjjij]: M.dynCall_viiiijjjij,
  [M.invoke_viiijjji]: M.dynCall_viiijjji,
  [M.invoke_viijj]: M.dynCall_viijj,
  [M.invoke_viijjiiiiiiijiijiiiii]: M.dynCall_viijjiiiiiiijiijiiiii,
  [M.invoke_vijjj]: M.dynCall_vijjj,
  [M.invoke_vijjji]: M.dynCall_vijjji,
  [M.invoke_vijjjij]: M.dynCall_vijjjij,
  [M.invoke_vj]: M.dynCall_vj,
  [M.invoke_vji]: M.dynCall_vji,
  [M.invoke_vjii]: M.dynCall_vjii,
  [M.invoke_vjiiii]: M.dynCall_vjiiii,
  [M.invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj]: M.dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj,
  [M.invoke_vjiiiiiiiijjjjj]: M.dynCall_vjiiiiiiiijjjjj,
  [M.invoke_vjiiiij]: M.dynCall_vjiiiij,
  [M.invoke_vjiij]: M.dynCall_vjiij,
  [M.invoke_vjiijiii]: M.dynCall_vjiijiii,
  [M.invoke_vjiijj]: M.dynCall_vjiijj,
  [M.invoke_vjij]: M.dynCall_vjij,
  [M.invoke_vjijj]: M.dynCall_vjijj,
  [M.invoke_vjijjjj]: M.dynCall_vjijjjj,
  [M.invoke_vjj]: M.dynCall_vjj,
  [M.invoke_vjji]: M.dynCall_vjji,
  [M.invoke_vjjii]: M.dynCall_vjjii,
  [M.invoke_vjjiii]: M.dynCall_vjjiii,
  [M.invoke_vjjiiiijj]: M.dynCall_vjjiiiijj,
  [M.invoke_vjjiiij]: M.dynCall_vjjiiij,
  [M.invoke_vjjiiijj]: M.dynCall_vjjiiijj,
  [M.invoke_vjjij]: M.dynCall_vjjij,
  [M.invoke_vjjiji]: M.dynCall_vjjiji,
  [M.invoke_vjjijj]: M.dynCall_vjjijj,
  [M.invoke_vjjj]: M.dynCall_vjjj,
  [M.invoke_vjjji]: M.dynCall_vjjji,
  [M.invoke_vjjjii]: M.dynCall_vjjjii,
  [M.invoke_vjjjiii]: M.dynCall_vjjjiii,
  [M.invoke_vjjjijji]: M.dynCall_vjjjijji,
  [M.invoke_vjjjj]: M.dynCall_vjjjj,
  [M.invoke_vjjjji]: M.dynCall_vjjjji,
  [M.invoke_vjjjjii]: M.dynCall_vjjjjii,
  [M.invoke_vjjjjiij]: M.dynCall_vjjjjiij,
  [M.invoke_vjjjjiijj]: M.dynCall_vjjjjiijj,
  [M.invoke_vjjjjij]: M.dynCall_vjjjjij,
  [M.invoke_vjjjjj]: M.dynCall_vjjjjj,
}
